import { BaseStore } from "@/supreme-core";
let state = {
  page: 1,
  data: {}
};
let mutations = {
  setCarType(state, selectedCarType) {
    state.selectedCarType = selectedCarType;
  },
  setData(state, data) {
    state.data = data;
  },
  getList(state, data) {}
};
var store = BaseStore.getInstance({
  name: "homeState",
  state: state,
  mutations: mutations
});
export default {
  ...store
};
